
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsOptional, IsString, IsUUID } from "class-validator";

export class LevelDto {
  @ApiPropertyOptional({ description: 'ID du niveau', type: 'string' })
  @IsOptional()
  @IsUUID()
  id?: string;

  @ApiPropertyOptional({ description: 'Code du niveau', type: 'string' })
  @IsOptional()
  @IsString()
  code?: string;

  @ApiPropertyOptional({ description: 'Label du niveau', type: 'string' })
  @IsOptional()
  @IsString()
  label?: string;
}
